import Card from "components/card/Card";
import TextEditor from "components/textEditor/textEditor";
import React from "react";
import { useTranslation } from "react-i18next";
import { ILoyaltyProgram } from "redux/reducers/models/loyalty";

interface IProps {
    loyaltyProgram: ILoyaltyProgram;
    setLoyaltyProgram: React.Dispatch<React.SetStateAction<ILoyaltyProgram>>;
}

export default function LoyaltyTerms(props: IProps) {
    const {loyaltyProgram, setLoyaltyProgram} = props;
    const {t} = useTranslation();

    return (
        <Card title={t("Terms and Conditions")} subtitle={t("Enter the terms and conditions for your loyalty program")}>
            <Card.Section>
            <TextEditor
                markdownText={loyaltyProgram?.terms ?? ""}
                markdownTextOnChange={terms => setLoyaltyProgram(prevState => ({ ...prevState, terms: terms }))}
                label={t("Terms and Conditions")}
              />
            </Card.Section>
        </Card>
    );
}